import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { CatalogReferenceKind } from '../../../api/types';
import { catalogReferenceApi, referenceId, referenceName } from './catalogReferenceApi';

export function useCatalogReferenceOptions(kind: CatalogReferenceKind, value: string) {
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('');
  useEffect(() => {
    const timer = window.setTimeout(() => setQuery(search.trim()), 250);
    return () => window.clearTimeout(timer);
  }, [search]);
  const references = useQuery({ queryKey: ['catalog', 'references', kind, query], queryFn: () => catalogReferenceApi.list(kind, query) });
  const selected = useQuery({ queryKey: ['catalog', 'reference', kind, value], queryFn: () => catalogReferenceApi.list(kind, '', 1, Number(value)), enabled: value !== '' });
  const available = [...(selected.data?.items ?? []), ...(references.data?.items ?? [])];
  const seen = new Set<number>();
  const options = available.filter((reference) => { const id = referenceId(reference); if (seen.has(id)) return false; seen.add(id); return true; }).map((reference) => ({ value: String(referenceId(reference)), label: referenceName(reference) }));
  return { options, setSearch, isLoading: references.isFetching, error: references.error ?? selected.error };
}
